import React from "react";
// Assuming you are using 'useHistory' from 'react-router-dom' inside the component where this is rendered,
// OR you are passing 'history' as a prop.
import { Container, Row, Col, Button } from "react-bootstrap";
import ImgWebp from "../Healthcare Software/Img/patnerwithus.gif";
import Img2 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 2.webp";
import Img3 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 3.webp";
import Img4 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 4.webp";
import Img5 from "../Healthcare Software/Img/medisevashospitalerpImg/imghomepagebanner 5.webp";

const servicesData = [
  // ... (your servicesData remains unchanged)
  {
    imgSrc: Img2,
    imgAlt: "Hero Image",
    title: "Impressive Prescriptions to Amaze your Patients.",
    description: `We recognize the necessity for the "Ideal Prescription". For your patients, it represents the sole concrete result of all the work you are investing in EMR. Transition to the next generation of prescription technology. Any format, any assortment of data, essential charts, laboratory trends, or visuals. Are you weary of hearing, 'it cannot be accomplished' - reach out to us. Any design you can envision, we can bring it to life.`,
    imgFirst: true,
  },
  {
    imgSrc: Img3,
    imgAlt: "Hero Image",
    title: "Extremely user-friendly EMR, tailored specifically for your needs.",
    description: `Our groundbreaking technology employs clinical intelligence to convert all of your paper forms and consents into digital format. You have the ability to further customize it to align with your workflows. The final outcome is a personalized EMR tailored specifically for you. This system includes only the essential elements you require. No excess, no distractions, no disarray.`,
    imgFirst: false,
  },
  {
    imgSrc: Img4,
    imgAlt: "Hero Image",
    title: "360 Degree View On Visits.",
    description: `Our 360-degree view on visits provides a comprehensive understanding of patient interactions. It consolidates all relevant data, ensuring that healthcare providers have a complete picture of each patient's journey. This holistic approach enhances decision-making and improves patient outcomes.`,
    imgFirst: true,
  },
  {
    imgSrc: Img5,
    imgAlt: "Hero Image",
    title: "An image can convey a multitude of meanings.",
    description: `Utilize the intelligent imaging tool available on the Medisevas cloud platform. It automatically filters the library according to the patient's gender. It connects directly to your camera, allowing you to capture images directly within Medisevas. You can annotate, highlight, and compare Before & After images, among other features.`,
    imgFirst: false,
  },
];

// ********************************************************************
// FIX: Accepting 'history' as a prop and defining 'navigateAndScroll'
// ********************************************************************
const HomeopathyClinicalModule = ({ history }) => {
  // Navigation function matching the user's requirement
  const navigateAndScroll = (path) => (e) => {
    e.preventDefault();
    if (history && typeof history.push === "function") {
      history.push(path);
    } else {
      // Fallback for non-router environments or modern react-router-dom v6 (replace with useNavigate hook)
      // If history is not available, it still performs the scroll and navigates via native URL change
      window.location.href = path;
    }
    window.scrollTo(0, 0);
  };

  return (
    <>
    
      <div>
        {/* 1. Features/Tabs Section */}
        <section id="features" className="features section "style={{marginTop:"80px"}}>
          <Container className="section-title text-center mb-5">
            <h2>
              Why Choose The Medisevas Cloud-based Healthcare Software &amp;
              Solutions
            </h2>
            <p>
              Providing accurate data, smooth department integration, and
              adaptable solutions that boost overall effectiveness and patient
              care, Medisevas Software is a dependable hospital management
              system that improves hospital operations.
            </p>
          </Container>
          <Container>
            <div className="d-flex justify-content-center">
              <ul
                className="nav nav-tabs nav-justified shadow-sm"
                id="featuresTab"
                role="tablist"
              >
                {/* Tabs */}
                {[
                  "OPD Management",
                  "Appointment Scheduling",
                  "Billing",
                  "Store & Pharmacy",
                  "Telehealth, Video Conferencing",
                  "Account Management",
                  "HRMS, Payroll",
                  "Inventory & Supply Chain",
                  "Imaging",
                  "Referral",
                  "Insurance",
                  "MIS, Reporting",
                  "Analytics",
                  "Reception",
                ].map((tab, i) => (
                  <li className="nav-item" role="presentation" key={tab}>
                    <a
                      className={`nav-link${
                        tab === "BloodBank" ? " active show" : ""
                      }`}
                      id={`${tab.toLowerCase()}-tab`}
                      data-bs-toggle="tab"
                      href={`#features-tab-${i + 1}`}
                      role="tab"
                      aria-selected={tab === "BloodBank" ? "true" : "false"}
                      tabIndex={tab === "BloodBank" ? "0" : "-1"}
                    >
                      <h4>{tab}</h4>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="tab-content mt-1 pt-1" id="featuresTabContent">
              {/* Tab Panes */}
              {[
                {
                  title: "Outpatient (OPD) Managment",
                  desc: "Utilise our OPD Management System to effectively oversee outpatient services. It is intended to optimise patient registration, scheduling, and billing for smooth healthcare provision.",
                  featuresLeft: [
                    "Patient Registration",
                    "Appointment Scheduling",
                    "Billing and Invoicing",
                    "Queue Management",
                    "EHR (Electronic Health Record)",
                    "Integrated with Lab and Pharmacy",
                  ],
                  featuresRight: [
                    "Role Based Access Management",
                    "Report and Analytics",
                    "Communication Management",
                    "Multi-Location Management",
                    "Audio Video Consultation",
                    "Mobile App for Patients",
                  ],
                },
                {
                  title: "Appointment Scheduling",
                  desc: "Our Appointment Scheduling System streamlines the process of booking, managing, and tracking patient appointments, ensuring efficient use of resources and improved patient satisfaction.",
                  featuresLeft: [
                    "OPD Registration",
                    "Provision to set doctor’s available timings.",
                    "Patient can request for online appointment.",
                    "Doctor can manage appointments.",
                    "Doctor Occupancy Management",
                    "Appointment API",
                  ],
                  featuresRight: [
                    "Role Based Access Management",
                    "Report and Analytics",
                    "Appointments Notification",
                    "Pre-Appointment Checklist",
                    "Predefined Templates",
                    "Queue Management",
                  ],
                },
                {
                  title: "Billing Management",
                  desc: "Our Billing Management System streamlines the process of managing patient billing, ensuring accurate invoicing and improved financial tracking.",
                  featuresLeft: [
                    "Add service charges of Hospital.",
                    "Add service charges of Doctor.",
                    "Include the tax master in the billing.",
                    "Define payment terms and conditions.",
                    "Payment API Integration",
                    "Utility for advance collection.",
                  ],
                  featuresRight: [
                    "Automated billing processes.",
                    "Look up bills using simple search terms",
                    "Discharged billing management",
                    "Credit Management",
                    "Predefined Templates",
                    "360° View on Billing",
                  ],
                },
                {
                  title: "Pharmacy Management",
                  desc: "Our Pharmacy Management System streamlines the process of managing patient prescriptions, ensuring accurate dispensing and improved inventory tracking.",
                  featuresLeft: [
                    "Purchase management.",
                    "Inventory management.",
                    "Vendor & Supplier management.",
                    "Cash & Credit management.",
                    "Payment API Integration",
                    "Utility for advance collection.",
                  ],
                  featuresRight: [
                    "Alerts facility on minimum or zero stock.",
                    "Internal department issuance of drugs",
                    "Result distribution and reporting.",
                    "Quality control and assurance.",
                    "Multi-location inventory management",
                    "360° View on Inventory",
                  ],
                },
                {
                  title: "Telehealth Management",
                  desc: "Our Telehealth Management System streamlines the process of managing patient care, ensuring efficient workflows using telecommunication technologies like video conferencing and remote monitoring.",
                  featuresLeft: [
                    "Telehealth Note Management",
                    "Remote patient monitoring.",
                    "Virtual consultations.",
                    "Telehealth workflow optimization.",
                    "Remote patient education and engagement.",
                  ],
                  featuresRight: [
                    "Telehealth care plan development.",
                    "Remote patient assessment.",
                    "Telehealth technology integration.",
                    "Patient feedback and satisfaction tracking.",
                    "360° View of Patient Journey",
                  ],
                },
                {
                  title: "Account Management",
                  desc: "Account Management System streamlines the process of managing financial accounts, ensuring accurate tracking and improved financial reporting.",
                  featuresLeft: [
                    "Account Creation and Management",
                    "Transaction History Tracking",
                    "Financial Reporting and Analytics",
                    "Budgeting and Forecasting",
                    "Integration with Banking Systems",
                  ],
                  featuresRight: [
                    "GST Compliance",
                    "Multi-Currency Support",
                    "Multi Location Accounting",
                    "Automated Tax Calculations",
                    "360° View of Financial Health",
                  ],
                },
                {
                  title: "HRMS, Payroll",
                  desc: "HRMS and Payroll System streamlines the process of managing employee records, ensuring efficient tracking and improved HR operations.",
                  featuresLeft: [
                    "Employee Information Management",
                    "Leave and Attendance Tracking",
                    "Payroll Processing and Management",
                    "Performance Evaluation and Management",
                    "Integration with HR Systems",
                  ],
                  featuresRight: [
                    "Recruitment Management",
                    "Onboarding and Offboarding Management",
                    "Employee Training and Development",
                    "Employee Self-Service Portal",
                    "360° View of Employee Operations",
                  ],
                },
                {
                  title: "Inventory Management",
                  desc: "The Inventory Management System streamlines the process of managing stock levels, ensuring efficient tracking and improved inventory operations.",
                  featuresLeft: [
                    "Stock Level Monitoring",
                    "Order Management",
                    "Supplier Management",
                    "Inventory Valuation",
                    "Integration with Sales Systems",
                  ],
                  featuresRight: [
                    "Warehouse Management",
                    "Inventory Tracking",
                    "Barcode Scanning",
                    "Real-time Stock Updates",
                    "360° View of Inventory",
                  ],
                },
                {
                  title: "Health Imaging Management",
                  desc: "DICOM and Health Imaging Management System streamlines the process of managing medical images, ensuring efficient tracking and improved patient care.",
                  featuresLeft: [
                    "Dicom Management",
                    "Patient Health Imaging Management",
                    "Image Storage and Retrieval",
                    "Integration with PACS",
                    "Advanced Image Analytics",
                  ],
                  featuresRight: [
                    "Image Compare Tool for Doctors",
                    "Image Annotation and Markup",
                    "Image Quality Assessment",
                    "Image Segmentation",
                    "360° View of Patient Health",
                  ],
                },
                {
                  title: "Referral Management",
                  desc: "Hospital Referral Management System streamlines the process of managing patient referrals, ensuring efficient tracking and improved patient care.",
                  featuresLeft: [
                    "Referral Management for Patients",
                    "Referral Tracking and Follow-up",
                    "Integration with EHR",
                    "Patient Communication Tools",
                    "Referral Analytics Dashboard",
                  ],
                  featuresRight: [
                    "Referral charge management",
                    "Referral Prioritization",
                    "Referral Outcome Tracking",
                    "Referral Documentation Management",
                    "360° View of Patient",
                  ],
                },
                {
                  title: "Insurance Management",
                  desc: "Insurance Management System streamlines the process of managing insurance policies, ensuring efficient tracking and improved customer service.",
                  featuresLeft: [
                    "Insurance Policy Management",
                    "Claims Processing and Tracking",
                    "Integration with EHR",
                    "Patient Communication Tools",
                    "Insurance Analytics Dashboard",
                  ],
                  featuresRight: [
                    "Settlement Management",
                    "Insurance Prioritization",
                    "Insurance Outcome Tracking",
                    "Insurance Documentation Management",
                    "360° View of Insurance",
                  ],
                },
                {
                  title: "MIS, Reporting",
                  desc: "Management Information System (MIS) provides comprehensive reporting and analytics capabilities, enabling data-driven decision-making.",
                  featuresLeft: [
                    "MIS Dashboard",
                    "Custom Reporting",
                    "Data Visualization Tools",
                    "OPD Collection report",
                    "Claims Analysis report",
                  ],
                  featuresRight: [
                    "MIS Integration",
                    "Stock purchase requisitions",
                    "Hospital revenue service wise report",
                    "Patient demographics report",
                    "360° View of MIS",
                  ],
                },
                {
                  title: "Clinic Analytics Management",
                  desc: "Hospital Analytics Management System provides comprehensive reporting and analytics capabilities, enabling data-driven decision-making.",
                  featuresLeft: [
                    "Analytics Dashboard",
                    "Custom Reporting",
                    "Data Visualization Tools",
                    "Predictive Analytics",
                    "Patient Flow Analytics",
                  ],
                  featuresRight: [
                    "Power BI Integration",
                    "Hospital API Integration",
                    "Data Warehouse Integration",
                    "Custom API Development",
                    "360° View of Analytics",
                  ],
                },
                {
                  title: "Reception Management",
                  desc: "Reception Management System provides comprehensive reporting and analytics capabilities, enabling data-driven decision-making.",
                  featuresLeft: [
                    "Patient Registration(IPD & OPD)",
                    "Generate Patient ID Card",
                    "Appointment Scheduling",
                    "Bed Allotment",
                    "Insurance Claims",
                  ],
                  featuresRight: [
                    "Blood Donor Registration",
                    "Patient Discharge Management",
                    "Consent Forms",
                    "Billing & Payment",
                    "360° View of Desk",
                  ],
                  title: "Homeopathy Clinic Software",
                  desc: "Homeopathy Clinic Software provides comprehensive reporting and Materia Medica capabilities, enabling data-driven Repertory decision-making.",
                  featuresLeft: [
                    "Homeopathic Consultation",
                    "Materia Medica Management",
                    "Appointment Scheduling",
                    "Patient Records Management",
                    "Prescription Management",
                  ],
                  featuresRight: [
                    "Repertory Management",
                    "Case Management",
                    "Filter Repertory",
                    "Billing & Payment",
                    "360° View of Patient",
                  ],
                },
              ].map(({ title, desc, featuresLeft, featuresRight }, i) => (
                <div
                  className={`tab-pane fade${
                    title === "Homeopathy Clinic Software" ? " active show" : ""
                  }`}
                  id={`features-tab-${i + 1}`}
                  role="tabpanel"
                  aria-labelledby={`${title
                    .toLowerCase()
                    .replace(/\s/g, "-")}-tab`}
                  key={title}
                >
                  <div className="row align-items-center ">
                    <div className="col-lg-7 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                      <h3>{title}</h3>
                      <p className="fst-italic">{desc}</p>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", paddingRight: "15px" }}>
                              <ul>
                                {featuresLeft.map((feat, idx) => (
                                  <li key={idx}>
                                    <i className="bi bi-check2-all"></i>{" "}
                                    <span>{feat}</span>
                                  </li>
                                ))}
                              </ul>
                            </td>
                            <td style={{ width: "50%", paddingLeft: "15px" }}>
                              <ul>
                                {featuresRight.map((feat, idx) => (
                                  <li key={idx}>
                                    <i className="bi bi-check2-all"></i>{" "}
                                    <span>{feat}</span>
                                  </li>
                                ))}
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-lg-5 order-1 order-lg-2 text-center">
                      <img
                        src={ImgWebp}
                        alt="Features Illustration"
                        className="img-fluid"
                        draggable={false}
                        style={{ height:"450px" }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </section>

        {/* 2. Services Section - Alternating Blocks */}
        <section id="services" className="services section light-background">
          <Container>
            <div className="section-title text-center mb-5">
              <h2>Achieve More With Medisevas HealthCare Software</h2>
              <p>
                Designed to operate locally for your convenience.Appreciated
                worldwide across various continents.
              </p>
            </div>

            <Row className="g-5">
              {servicesData.map((service, idx) => (
                <Col key={idx} lg={12}>
                  <div className="service-card">
                    {service.imgFirst && (
                      <div className="service-img-wrapper">
                        <img
                          src={service.imgSrc}
                          alt={service.imgAlt}
                          className="img-fluid"
                          draggable={false}
                        />
                      </div>
                    )}
                    <div className="service-text">
                      <h4>{service.title}</h4>
                      <p>{service.description}</p>
                    </div>
                    {!service.imgFirst && (
                      <div className="service-img-wrapper">
                        <img
                          src={service.imgSrc}
                          alt={service.imgAlt}
                          className="img-fluid"
                          draggable={false}
                        />
                      </div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* 3. CTA Section - Buttons now use navigateAndScroll */}
        <section className="medisevas-section medisevas-dark-bg py-5">
          <div className="container text-center">
            <h3>
              Assisting You in Expanding Without Boundaries,
              <br />
              Your Development is Our Main Concern
            </h3>
            <p>
              Schedule a demonstration, and our representative will provide you
              with an in-depth overview of our product and address any lingering
              questions.
            </p>
            <div className="hero-buttons mb-3">
              {/* Contact with Us */}
              <a
                className="medisevas-btn medisevas-btn-outline mx-1"
                href="/contact-us"
                onClick={navigateAndScroll("/contact-us")}
              >
                Contact with Us
              </a>

              {/* Book a Demo */}
              <a
                className="medisevas-btn medisevas-btn-success mx-1"
                href="/contact-us"
                onClick={navigateAndScroll("/contact-us")}
              >
                Book a Demo
              </a>

              {/* Partner with Us */}
              <a
                className="medisevas-btn medisevas-btn-outline mx-1"
                href="/partner-with-us"
                onClick={navigateAndScroll("/partner-with-us")}
              >
                Partner with Us
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default HomeopathyClinicalModule;
